import script from "./wArtworkCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./wArtworkCard.vue?vue&type=script&lang=ts&setup=true"

import "./wArtworkCard.vue?vue&type=style&index=0&id=16465a72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16465a72"]])

export default __exports__